angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/modal/window.html",
    "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
    "");
}]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-ui-bootstrap/template/modal/window.html.js
// module id = 319
// module chunks = 6